import React from 'react';
import { ArrowUpOutlined, ArrowDownOutlined, MinusOutlined } from '@ant-design/icons';

export default function GrowthValue({ value, suffix = '%' }) {
  if (value === null || value === undefined) return <span style={{ color: '#999' }}>-</span>;
  if (value === 0) return <span style={{ color: '#999' }}><MinusOutlined /> 0{suffix}</span>;
  const isPositive = value > 0;
  return (
    <span style={{ color: isPositive ? '#cf1322' : '#3f8600' }}>
      {isPositive ? <ArrowUpOutlined /> : <ArrowDownOutlined />}
      {' '}{Math.abs(value).toFixed(2)}{suffix}
    </span>
  );
}
